export default __webpack_public_path__ + "static/media/decada-2000-0002-min.60e29303.jpg";